import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { WizardComponent } from "./wizard.component";
import { InfoService } from "../services/info.service";

enum PaymentStatus {
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  FAILURE = "FAILURE",
}

@Component({
  selector: "app-thank-you",
  templateUrl: "./thank-you.component.html",
})
export class ThankYouComponent implements OnInit {
  message: string;
  success: boolean = false;
  petInfo : string;
  constructor(private route: ActivatedRoute, private router: Router, public infoService: InfoService) { 

  }

  pet_names: string = "";
  start_time_str: string = "";
  end_time_str: string = "";
  displayAddress: string = "";
  showEndTimeInSummary:any;

  ngOnInit(): void {
    let status = this.route.snapshot.queryParamMap.get("status");
    this.pet_names = localStorage.getItem('pet_names');
    this.start_time_str = localStorage.getItem('start_time_str');
    this.end_time_str = localStorage.getItem('end_time_str');
    this.displayAddress = localStorage.getItem('displayAddress');
    this.showEndTimeInSummary = localStorage.getItem('showEndTimeInSummary');
    if(this.showEndTimeInSummary == true || this.showEndTimeInSummary == 'true'){
      this.showEndTimeInSummary = true;
    }
    else{
      this.showEndTimeInSummary = false;
    }
    if(this.displayAddress == 'undefined'){
      this.displayAddress="";
    }
    if (this.showEndTimeInSummary) {
      this.petInfo = `Your appointment has been successfully confirmed.\nWe can't wait to see ${this.pet_names} at ${this.start_time_str} To ${this.end_time_str} at ${this.displayAddress}`;
    }
    else {
      this.petInfo = `Your appointment has been successfully confirmed.\nWe can't wait to see ${this.pet_names} at ${this.start_time_str} at ${this.displayAddress}`;
    }
    this.infoService.getAppointmentDetail(this.infoService.appointmentKey).subscribe((res: any) => {
      if (res && res.data) {
        if (res.data.status != 'CONFIRMED') {
          this.petInfo = `Your appointment request has been received and will be reviewed shortly .\n We are looking forward to seeing ${this.pet_names}`;
        }
      }
    })
    switch (status) {
      case PaymentStatus.APPROVED:
        this.success = true;
        this.message = "Thank you for your payment" + this.petInfo;
        break;
      case PaymentStatus.CANCELLED:
        this.message = "Your transaction has been canceled.";
        break;
      case PaymentStatus.FAILURE:
        this.message = "Your transaction has failed.";
        break;
      default:
        this.message = "Your transaction has been canceled.";
    }
  }

  goToAppointmentPage() {
      
    this.router.navigate(["/"]).then(() => window.location.reload());
  }

}
